<template>
    <b-container v-if="$can('view-sales-orders') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Orders</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" @click="recalc(); submittingRecalc = 1" v-if="this.tables.salesOrders.selected.length" :disabled="submittingRecalc == 1">
                            <span v-if="submittingRecalc">
                                <b-spinner small type="grow"></b-spinner>
                                Recalculating Orders...
                            </span>
                            <span v-else>Recalc</span>
                        </b-button>
                        <b-button v-if="$can('view-all') || $can('view-payments')" variant="outline-primary" size="sm" @click="openModal('receive-payment')">Receive
                            Payment</b-button>
                        <!-- <b-button variant="outline-primary" size="sm" @click="openModal('apply-credit')">Apply Credit
                        </b-button> -->
                        <b-button variant="outline-primary" size="sm" :to="{ name: 'SalesOrdersCreate' }">New Order
                        </b-button>
                        <b-button v-if="$can('execute-export') || $can('view-all')" variant="outline-primary" size="sm" @click="openModal('export-columns')">Export
                        </b-button>
                        <b-button v-if="$can('execute-export') || $can('view-all')" variant="outline-primary" size="sm" @click="exportLineItemsExcel">
                            <span v-if="exports.loadingLineItems">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Exporting Line Items...</strong>
                            </span>
                            <span v-else>Export Line Items</span>
                        </b-button>
                        <b-button v-if="$can('execute-export') || $can('view-all')" variant="outline-primary" size="sm" @click="exportSalesByItem">
                            <span v-if="exports.loadingSalesByItem">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Exporting Sales By Item...</strong>
                            </span>
                            <span v-else>Export Sales By Item</span>
                        </b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('adjust-columns')"><i
                                class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>
        <b-row>
            <b-container fluid>
                <div class="sales-orders-filters d-flex flex-wrap align-items-start">
                    <div class="sales-orders-filter sales-orders-filter--search">
                        <shopify-style-filter-bar
                            :search.sync="tables.salesOrders.filter"
                            :clearable="hasActiveSalesOrderFilters"
                            :fields="shopifyFilterFields"
                            :value="shopifyFilterValue"
                            @change="onShopifyFilterChange"
                            @clear="clearFilters"
                        />
                    </div>

                    <div class="sales-orders-filter sales-orders-filter--date">
                        <b-form-datepicker id="input-date-from" v-model="filters.selected.dateFrom"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" class="mb-2"
                            placeholder="From" today-button close-button reset-button @input="filterSelect($event, 'dateFrom')" :disabled="filters.selected.dateFilter != null">
                        </b-form-datepicker>
                    </div>

                    <div class="sales-orders-filter sales-orders-filter--date">
                        <b-form-datepicker id="input-date-to" v-model="filters.selected.dateTo"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" class="mb-2"
                            placeholder="To" today-button close-button reset-button @input="filterSelect($event, 'dateTo')" :disabled="filters.selected.dateFilter != null">
                        </b-form-datepicker>
                    </div>

                    <div class="sales-orders-filter sales-orders-filter--select">
                        <treeselect name="filtersDateFilterSelect" class="filters-date-filter-select" clearable :searchable="false" open-on-click
                            clear-on-select close-on-select disableBranchNodes placeholder="Period" :options="filters.dateFilters"
                            @input="filterSelect($event, 'dateFilter')" :value="filters.selected.dateFilter" ref="selectDateFilter" />
                    </div>

                    <div class="sales-orders-filter sales-orders-filter--select">
                        <treeselect name="filtersStatusSelect" class="filters-status-select" clearable
                            :searchable="false" open-on-click clear-on-select close-on-select disableBranchNodes
                            placeholder="Status" :options="filters.status" @input="filterSelect($event, 'status')"
                            :value="filters.selected.status" multiple ref="selectStatus" />
                    </div>

                    <div class="sales-orders-filter sales-orders-filter--select">
                        <treeselect name="filtersSalesRepsSelect" class="filters-sales-reps" clearable
                            :searchable="false" open-on-click clear-on-select close-on-select disableBranchNodes
                            placeholder="Sales Reps" :options="filters.salesReps"
                            @input="filterSelect($event, 'salesReps')" :value="filters.selected.salesReps" multiple ref="selectSalesReps" />
                    </div>

                    <div class="sales-orders-filter sales-orders-filter--select">
                        <treeselect name="filtersTags" class="filters-tags" clearable searchable open-on-click
                            clear-on-select close-on-select disableBranchNodes placeholder="Tags"
                            :options="filters.tags" @input="filterSelect($event, 'tags')" :value="filters.selected.tags" multiple ref="selectTags" />
                    </div>

                    <div class="sales-orders-filter sales-orders-filter--perpage">
                        <b-form-group class="mb-2">
                            <b-form-select v-model="tables.salesOrders.perPage" id="perPageSelect" size="sm"
                                :options="tables.salesOrders.pageOptions"></b-form-select>
                        </b-form-group>
                    </div>
                </div>

                <b-row class="row-sales-orders-table d-none d-md-block">
                    <b-container fluid>
                        <b-table v-if="tables.salesOrders.ready" ref="salesOrdersTable" :key="tables.salesOrders.key"
                            class="sales-orders-table" responsive bordered striped hover no-border-collapse
                            sticky-header="calc(100vh - 250px)" head-variant="light" :items="salesOrdersProvider"
                            :fields="visibleFields" :sort-by.sync="tables.salesOrders.sortBy"
                            :sort-desc.sync="tables.salesOrders.sortDesc" :per-page="tables.salesOrders.perPage"
                            :current-page.sync="tables.salesOrders.currentPage" :filter="tables.salesOrders.filter"
                            :busy.sync="tables.salesOrders.isBusy">

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:head(checkbox)="row">
                                <b-form-checkbox v-model="tables.salesOrders.allSelected" @change="toggleAll">
                                </b-form-checkbox>
                            </template>

                            <template v-slot:cell(checkbox)="row">
                                    <b-form-checkbox :value="row.item.id" v-model="tables.salesOrders.selected" />
                                </template>

                            <template v-slot:cell(id)="row">
                                <b-link :ref="'ordersTableRow' + row.item.id"
                                    @click="saveState('ordersTableRow' + row.item.id)" :to="{name: 'SalesOrderDetail', params: { soNum: row.item.sales_order_number } }">{{ row.item.id }}
                                </b-link>
                            </template>

                            <template v-slot:cell(sales_order_number)="row">
                                <b-link :ref="'ordersTableRow' + row.item.id"
                                    @click="saveState('ordersTableRow' + row.item.id)"
                                    :to="{name: 'SalesOrderDetail', params: { soNum: row.item.sales_order_number } }">{{
                                    displayOrderNumber(row.item) }}</b-link>
                            </template>

                            <template v-slot:cell(customer)="row">
                                <b-link v-if="row.item.customer" :to="{name: 'CustomerDetail', params: { id: row.item.customer.id } }">{{
                                row.item.customer.name }}</b-link>
                            </template>

                            <template v-slot:cell(net_total)="row">
                                <span>${{ numberWithCommas(row.item.subtotal - row.item.discount_total - row.item.credit_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(cogs)="row">
                                <div v-if="($can('view-all') || $can('view-product-cost'))">
                                    <span v-if="row.item.status == 'Closed'">${{ numberWithCommas(row.item.cogs) }}</span>
                                    <span v-else>N/A</span>
                                </div>
                            </template>

                            <template v-slot:cell(credit_total)="row">
                                <span>${{ numberWithCommas(row.item.credit_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(discount_total)="row">
                                <span>${{ numberWithCommas(row.item.discount_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(percent_discounts)="row">
                                <span>{{ percentDiscounts(row.item) }}</span>
                            </template>

                            <template v-slot:cell(shipping_total)="row">
                                <span>${{ numberWithCommas(row.item.shipping_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(total)="row">
                                <span>${{ numberWithCommas(row.item.total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(sales_rep)="row">
                                <span v-if="row.item.sales_rep">{{ row.item.sales_rep.name }}</span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(sale_order_tag)="row">
                                <span v-if="row.item.sale_order_tag">
                                    <b-badge v-for="(tag, index) in row.item.sale_order_tag" :key="index" pill
                                        variant="secondary" class="tag-badges">{{ tag.orders_tag.name }}</b-badge>
                                </span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <!-- <b-col>
                                            <b-link @click="openModal('listing', row.item, 'edit')"><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <b-col>
                                            <b-link @click="showMsgBoxDeleteConfirm('invoices', row.item)" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                        <!-- <b-col>
                                            <b-link @click=""><i class="far fa-check-square"></i></b-link>
                                        </b-col> -->
                                        <b-col>
                                            <b-link
                                                :to="{name: 'SalesOrderDetail', params: { soNum: row.item.sales_order_number } }">
                                                <i class="fas fa-edit"></i>
                                            </b-link>
                                        </b-col>
                                        <b-col v-if="$can('view-all')">
                                            <b-link @click="deleteConfirm(row.item)" class="icon-danger">
                                                <i class="fas fa-trash-alt"></i>
                                            </b-link>
                                        </b-col>
                                        <!-- <b-col>
                                            <b-link @click="" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <div class="sales-orders-mobile d-md-none">
                    <div v-if="tables.salesOrders.isBusy" class="text-center text-default my-3">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-2">Loading...</strong>
                    </div>
                    <div v-else-if="!tables.salesOrders.items.length" class="text-muted text-center py-4">
                        No orders found.
                    </div>
                    <div
                        v-for="item in tables.salesOrders.items"
                        :key="'mobile-order-' + item.id"
                        class="sales-orders-mobile__card"
                    >
                        <div class="d-flex justify-content-between align-items-start mb-2">
                            <div>
                                <b-link
                                    :to="{ name: 'SalesOrderDetail', params: { soNum: item.sales_order_number } }"
                                    class="font-weight-bold"
                                >
                                    #{{ displayOrderNumber(item) }}
                                </b-link>
                                <div class="text-muted small" v-if="item.customer">
                                    <b-link :to="{ name: 'CustomerDetail', params: { id: item.customer.id } }">
                                        {{ item.customer.name }}
                                    </b-link>
                                </div>
                            </div>
                            <b-badge :variant="mobileStatusVariant(item.status)">{{ item.status }}</b-badge>
                        </div>
                        <div class="sales-orders-mobile__meta">
                            <div>
                                <span class="text-muted">Net</span>
                                <strong>${{ numberWithCommas(item.subtotal - item.discount_total - item.credit_total) || '0.00' }}</strong>
                            </div>
                            <div>
                                <span class="text-muted">Balance</span>
                                <strong>${{ numberWithCommas(item.balance) || '0.00' }}</strong>
                            </div>
                            <div>
                                <span class="text-muted">Rep</span>
                                <strong>{{ item.sales_rep ? item.sales_rep.name : '—' }}</strong>
                            </div>
                        </div>
                        <div class="mt-2 text-right">
                            <b-link :to="{ name: 'SalesOrderDetail', params: { soNum: item.sales_order_number } }">
                                <i class="fas fa-edit"></i> Edit
                            </b-link>
                            <b-link v-if="$can('view-all')" @click="deleteConfirm(item)" class="icon-danger ml-3">
                                <i class="fas fa-trash-alt"></i> Delete
                            </b-link>
                        </div>
                    </div>
                </div>

                <b-row>
                    <b-col cols="12" md="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="12" md="6" class="my-1">
                        <b-pagination v-model="tables.salesOrders.currentPage"
                            :total-rows="tables.salesOrders.totalRows" :per-page="tables.salesOrders.perPage"
                            align="fill" size="sm" class="my-0"></b-pagination>
                    </b-col>
                </b-row>

                <modal-receive-payment v-if="modals['receive-payment'].active" />

                <modal-apply-credit v-if="modals['apply-credit'].active" />

                <modal-adjust-columns v-if="modals['adjust-columns'].active" :fields="modals['adjust-columns'].fields"
                    @saveColSaves="saveColSaves" />

                <modal-export-columns v-if="modals['export-columns'].active" :fields="modals['export-columns'].fields"
                    :ignores="modals['export-columns'].ignores" @exportExcel="exportExcel" />

                <modal-export-line-items v-if="modals['export-line-items'].active" />
            </b-container>
        </b-row>
    </b-container>
</template>

<script>
    import store from '../../../store'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ModalReceivePayment from '../lists/customers/modals/ReceivePayment'
    import ModalApplyCredit from '../lists/customers/modals/ApplyCredit'
    import ModalAdjustColumns from '../common/modals/AdjustColumns'
    import ModalExportColumns from '../common/modals/ExportColumns'
    import ModalExportLineItems from '../common/modals/ExportLineItems'
    import tableColumnPreferences from '../../../mixins/tableColumnPreferences'
    import urlQueryFilters from '../../../mixins/urlQueryFilters'
    import ShopifyStyleFilterBar from '../../../components/ShopifyStyleFilterBar'
    import { fetchActivePaymentTerms, paymentTermsToFilterOptions } from '../../../utils/paymentTerms'
    import { fetchActiveShippingMethods, shippingMethodsToFilterOptions } from '../../../utils/shippingMethods'
 	export default {
    	name: 'SalesOrders',

        mixins: [tableColumnPreferences, urlQueryFilters],

        metaInfo() {
            return {
                title: 'Orders',
            }
        },

    	components: {
      		Treeselect,
            'shopify-style-filter-bar': ShopifyStyleFilterBar,
            'modal-receive-payment': ModalReceivePayment,
            'modal-apply-credit': ModalApplyCredit,
            'modal-adjust-columns': ModalAdjustColumns,
            'modal-export-columns': ModalExportColumns,
            'modal-export-line-items': ModalExportLineItems
    	},
        data() {
            return {
                modals: {
                    'create-sales-order': {
                        create: {
                            active: 1
                        },
                        key: 1,
                        submitting: 0,
                        statusSelected: []
                    },

                    'edit-sales-order': {
                        edit: [],
                        key: 1,
                        submitting: 0
                    },

                    'receive-payment': {
                        active: 0
                    },

                    'apply-credit': {
                        active: 0
                    },

                    'adjust-columns': {
                        active: 0,
                        fields: []
                    },

                    'export-columns': {
                        active: 0,
                        fields: [],
                        ignores: ['checkbox', 'actions']
                    },

                    'export-line-items': {
                        active: 0
                    }
                },
                tables: {
                    salesOrders: {
                        selected: [],
                        allSelected: false,
                        filteredItems: [],
                        isBusy: false,
                        totalRows: 0,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'date',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        userFields: [],
                        fields: [
                            {
                                key: 'checkbox',
                                label: '',
                                visible: 1
                            },
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'sales_order_number',
                                label: 'Invoice #',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'customer',
                                label: 'Customer Name',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'credit_total',
                                label: 'Credits',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'shipping_total',
                                label: 'Shipping Fee',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'discount_total',
                                label: 'Discounts',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'percent_discounts',
                                label: '% Discounts',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'net_total',
                                label: 'Net Total',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'status',
                                label: 'Status',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'total',
                                label: 'Total',
                                sortable: true,
                                visible: 1
                            },
                            // {
                            //     key: 'customer.balance',
                            //     label: 'Total Balance',
                            //     sortable: true,
                            //     formatter: value => {
                            //         return '$' + this.numberWithCommas(value)
                            //     },
                            //     visible: 1
                            // },
                            {
                                key: 'balance',
                                label: 'Balance Due',
                                sortable: true,
                                formatter: value => {
                                    return '$' + this.numberWithCommas(value)
                                },
                                visible: 1
                            },
                            {
                                key: 'cogs',
                                label: 'COGS',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'source',
                                label: 'Source',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'date',
                                label: 'Order Placed',
                                sortable: true,
                                thClass: 'sales-orders-table-style-datetime',
                                visible: 1
                            },
                            {
                                key: 'date_shipped',
                                label: 'Order Shipped',
                                sortable: true,
                                thClass: 'sales-orders-table-style-datetime',
                                visible: 1
                            },
                            {
                                key: 'payment_method',
                                label: 'Payment Type',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'sales_rep',
                                label: 'Sales Rep',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'sale_order_tag',
                                label: 'Tags',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'sales-orders-table-style-actions',
                                visible: 1
                            }
                        ],
                        exportOnlyFields: [
                            {
                                key: 'billing_address_1',
                                label: 'Billing Address 1',
                                visible: 0
                            },
                            {
                                key: 'billing_address_2',
                                label: 'Billing Address 2',
                                visible: 0
                            },
                            {
                                key: 'billing_city',
                                label: 'Billing City',
                                visible: 0
                            },
                            {
                                key: 'billing_state',
                                label: 'Billing State',
                                visible: 0
                            },
                            {
                                key: 'billing_postal_code',
                                label: 'Billing Zip',
                                visible: 0
                            },
                            {
                                key: 'billing_country',
                                label: 'Billing Country',
                                visible: 0
                            },
                            {
                                key: 'shipping_address_1',
                                label: 'Shipping Address 1',
                                visible: 0
                            },
                            {
                                key: 'shipping_address_2',
                                label: 'Shipping Address 2',
                                visible: 0
                            },
                            {
                                key: 'shipping_city',
                                label: 'Shipping City',
                                visible: 0
                            },
                            {
                                key: 'shipping_state',
                                label: 'Shipping State',
                                visible: 0
                            },
                            {
                                key: 'shipping_postal_code',
                                label: 'Shipping Zip',
                                visible: 0
                            },
                            {
                                key: 'shipping_country',
                                label: 'Shipping Country',
                                visible: 0
                            }
                        ],

                        items: [],
                        categories: [],
                        ready: 0
                    },
                },

                filters: {
                    selected: {
                        dateFrom: '',
                        dateTo: '',
                        dateFilter: null,
                        salesReps: [],
                        status: [],
                        paymentTypes: [],
                        paymentTypesOperator: 'is',
                        shippingMethods: [],
                        shippingMethodsOperator: 'is',
                        columnFilters: {},
                        tags: []
                    },
                    salesReps: [],
                    status: [
                        {
                            id: 'Open',
                            label:'Open'
                        },
                        {
                            id: 'Pending',
                            label:'Pending'
                        },
                        {
                            id: 'Confirmed',
                            label:'Confirmed'
                        },
                        {
                            id: 'Dispatched',
                            label:'Dispatched'
                        },
                        {
                            id: 'Closed',
                            label:'Closed'
                        },
                        {
                            id: 'Cancelled',
                            label:'Cancelled'
                        }
                    ],
                    paymentTypes: [],
                    shippingMethods: [],
                    tags: [],
                    dateFilters: [
                        {
                            id: 'Last 7 Days',
                            label: 'Last 7 Days'
                        },
                        {
                            id: 'Last 30 Days',
                            label: 'Last 30 Days'
                        },
                        {
                            id: 'This Month',
                            label: 'This Month'
                        },
                        {
                            id: 'Year To Date',
                            label: 'Year To Date'
                        },
                        {
                            id: 'Last Month',
                            label: 'Last Month'
                        },
                        {
                            id: 'Last Year',
                            label: 'Last Year'
                        },
                        {
                            id: 'Last 365',
                            label: 'Last 365'
                        },
                        {
                            id: 'OlderThan30',
                            label: 'Older than 30 days'
                        },
                        {
                            id: 'OlderThan60',
                            label: 'Older than 60 days'
                        },
                        {
                            id: 'OlderThan90',
                            label: 'Older than 90 days'
                        }
                    ]
                },

                exports: {
                    cols: [],
                    loadingLineItems: false,
                    loadingSalesByItem: false,
                },

                submittingRecalc: 0
            }
        },
        methods: {
            displayOrderNumber(order) {
                if (!order) {
                    return ''
                }
                const document = order.document_order_number || order.display_order_number
                if (document !== null && document !== undefined && String(document).trim() !== '') {
                    return String(document).trim()
                }
                const marketplace = order.marketplace_order_number
                if (marketplace !== null && marketplace !== undefined && String(marketplace).trim() !== '') {
                    return String(marketplace).trim()
                }
                return order.sales_order_number
            },

            deleteConfirm(order) {
                const name = this.displayOrderNumber(order)
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete: ' + name, {
                    title: 'Delete: ' + name,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Confirm',
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.deleteSalesOrder(order.id)
                    }
                })
                .catch(() => {})
            },

            deleteSalesOrder(id) {
                axios.get('api/orders/sales-orders/delete/' + id)
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.refreshSalesOrdersTable()
                        this.showAlertBox('success', 'Order Deleted', 'Sales order deleted successfully!')
                    } else {
                        this.showAlertBox('danger', 'Delete Failed', res.data.message || 'Cannot delete this sales order.')
                    }
                }, (error) => {
                    const message = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Cannot delete this sales order.'
                    this.showAlertBox('danger', 'Delete Failed', message)
                })
            },

            percentDiscounts(item) {
                const discounts = Number(item.discount_total) || 0
                const netTotal = (Number(item.subtotal) || 0) - discounts - (Number(item.credit_total) || 0)
                const denominator = discounts + netTotal

                if (denominator === 0) {
                    return '0.00'
                }

                return ((discounts / denominator) * 100).toFixed(2)
            },

            recalc() {
                let url = 'api/orders/sales-orders/recalculatebatch'
                axios.post(url, {
                    ids: this.tables.salesOrders.selected
                })
                    .then((res) => {
                        this.tables.salesOrders.selected = []
                        this.refreshSalesOrdersTable()
                        this.showAlertBox('success', 'Order(s) Recalculated', 'Order(s) recalculated successfully!')
                        this.submittingRecalc = 0
                    }, () => {
                        this.has_error = true
                    })
            },

            toggleAll() {
                this.tables.salesOrders.selected = []

                if (this.tables.salesOrders.allSelected) {
                    for (let item of this.tables.salesOrders.items) {
                        this.tables.salesOrders.selected.push(item.id.toString())
                    }
                }
            },

            getSalesOrdersAuthGuard() {
                return {
                    isAdmin: this.$can('view-all'),
                    viewSelfOnly: this.$can('view-sales-order-self'),
                    authName: store.state.auth.user.name
                }
            },

            getSalesOrdersExportParams() {
                return {
                    filters: this.filters.selected,
                    search: this.tables.salesOrders.filter,
                    sortBy: this.tables.salesOrders.sortBy,
                    sortDesc: this.tables.salesOrders.sortDesc,
                    authGuard: this.getSalesOrdersAuthGuard()
                }
            },

            exportExcel(cols, keys) {
                let url = 'api/orders/sales-orders/exportsalesorders'
                axios.post(url, {
                    ...this.getSalesOrdersExportParams(),
                    cols: cols,
                    keys: keys
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
            },

            exportLineItemsExcel() {
                this.exports.loadingLineItems = true;
                axios.post('api/orders/sales-orders/exportlineitems', {
                    ...this.getSalesOrdersExportParams()
                }, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'line_items_export.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(error => {
                    console.error('Error exporting line items:', error);
                })
                .finally(() => {
                    this.exports.loadingLineItems = false;
                });
            },

            exportSalesByItem() {
                this.exports.loadingSalesByItem = true;
                axios.post('api/orders/sales-orders/exportsalesbyitem', {
                    ...this.getSalesOrdersExportParams()
                }, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sales_by_item_export.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(error => {
                    console.error('Error exporting sales by item:', error);
                })
                .finally(() => {
                    this.exports.loadingSalesByItem = false;
                });
            },

            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Sales_Orders_Export_File_' + +new Date() + '.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Sales Orders export file generated successfully!')
            },

            clearFilters() {
                this.tables.salesOrders.filter = ''
                this.filters.selected.dateTo = ''
                this.filters.selected.dateFrom = ''
                this.filters.selected.dateFilter = null
                this.filters.selected.status = []
                this.filters.selected.salesReps = []
                this.filters.selected.paymentTypes = []
                this.filters.selected.paymentTypesOperator = 'is'
                this.filters.selected.shippingMethods = []
                this.filters.selected.shippingMethodsOperator = 'is'
                this.filters.selected.columnFilters = {}
                this.filters.selected.tags = []

                if (this.$refs.selectStatus) this.$refs.selectStatus.clear()
                if (this.$refs.selectSalesReps) this.$refs.selectSalesReps.clear()
                if (this.$refs.selectDateFilter) this.$refs.selectDateFilter.clear()
                if (this.$refs.selectTags) this.$refs.selectTags.clear()

                this.tables.salesOrders.currentPage = 1
                this.syncUrlQueryFilters()
                this.refreshSalesOrdersTable()
            },

            openModal(modalName, row) {
                let prefix = 'modal-inventory-sales-orders-'
                switch (modalName) {
                    case 'edit-sales-order':
                        this.modals[modalName].edit = Object.assign({}, row)
                        // this.setCurrentUserRoles(row.roles)

                        break

                    case 'receive-payment':
                        this.modals[modalName].active = 1

                        break

                    case 'apply-credit':
                        this.modals[modalName].active = 1

                        break

                    case 'adjust-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = this.cloneFieldsForAdjust(this.tables.salesOrders.userFields, this.tables.salesOrders.fields)

                        break

                    case 'export-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify([
                            ...this.tables.salesOrders.fields.filter(e => !this.modals[modalName].ignores.includes(e.key)),
                            ...this.tables.salesOrders.exportOnlyFields
                        ]))

                        break

                    case 'export-line-items':
                        this.modals[modalName].active = 1

                        break;
                }

                if (modalName == 'receive-payment' || modalName == 'apply-credit') {
                    prefix = 'modal-lists-customers-'
                }

                if (modalName == 'adjust-columns' || modalName == 'export-columns' || modalName == 'export-line-items') {
                    prefix = 'modal-common-'
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },

            toggleBusy() {
                this.tables.salesOrders.isBusy = !this.tables.salesOrders.isBusy
            },

            setLastState() {
                this.$nextTick(() => {
                    if (this.rememberedOrder.name && this.rememberedOrder.page) {
                        this.tables.salesOrders.currentPage = this.rememberedOrder.page
                        this.$nextTick(() => {
                            this.$refs[this.rememberedOrder.name].$el.scrollIntoView()
                        })
                    }
                })
            },

            saveState(name) {
                let page = this.tables.salesOrders.currentPage
                let filter = this.tables.salesOrders.filter
                let perPage = this.tables.salesOrders.perPage
                let rowFilters = this.tables.salesOrders.rowFilters
                this.setRememberOrder({name: name, page: page, filter: filter, perPage: perPage, rowFilters: rowFilters })
            },

            salesOrdersProvider(ctx) {
                return this.scheduleProviderFetch('salesOrders', ctx, (latestCtx) => {
                    const normalized = this.normalizeTableProviderContext(latestCtx, this.tables.salesOrders)
                    let payload = {
                        ...this.getSalesOrdersExportParams(),
                        page: normalized.currentPage,
                        perPage: normalized.perPage,
                        sortBy: normalized.sortBy,
                        sortDesc: normalized.sortDesc,
                        search: normalized.filter
                    }

                    return axios.post('api/orders/sales-orders/getsalesorders', payload)
                    .then((res) => {
                        this.tables.salesOrders.items = res.data.orders
                        this.tables.salesOrders.totalRows = res.data.total
                        return res.data.orders || []
                    }, () => {
                        this.has_error = true
                        return []
                    })
                })
            },

            refreshSalesOrdersTable() {
                if (this.$refs.salesOrdersTable) {
                    this.$refs.salesOrdersTable.refresh()
                }
            },

            initSalesOrders() {
                this.tables.salesOrders.filter = this.rememberedOrder.filter || ''
                this.tables.salesOrders.perPage = this.rememberedOrder.perPage || 20
                this.tables.salesOrders.rowFilters = this.rememberedOrder.rowFilters || {}

                if (this.rememberedOrder.page) {
                    this.tables.salesOrders.currentPage = this.rememberedOrder.page
                }

                const appliedFromUrl = this.applyUrlQueryFilters()
                if (!appliedFromUrl && this.$route.params.status) {
                    this.processStatusQueryRoute(this.$route.params.status)
                }

                this.tables.salesOrders.ready = 1

                this.$nextTick(() => {
                    this.enableUrlQueryFilters()
                    this.setLastState()
                })
            },

            filterSelect(name, area) {
                this.filters.selected[area] = name
                this.tables.salesOrders.currentPage = 1

                if (area == 'dateFilter') {
                    this.filters.selected.dateFrom = ''
                    this.filters.selected.dateTo = ''
                }

                this.syncUrlQueryFilters()
                this.refreshSalesOrdersTable()
            },

            onShopifyFilterChange(next) {
                const payment = next.paymentTypes || { values: [], operator: 'is' }
                const shipping = next.shippingMethods || { values: [], operator: 'is' }

                this.filters.selected.paymentTypes = Array.isArray(payment.values) ? payment.values : []
                this.filters.selected.paymentTypesOperator = payment.operator === 'is_not' ? 'is_not' : 'is'
                this.filters.selected.shippingMethods = Array.isArray(shipping.values) ? shipping.values : []
                this.filters.selected.shippingMethodsOperator = shipping.operator === 'is_not' ? 'is_not' : 'is'

                const columnFilters = {}
                Object.keys(next || {}).forEach((key) => {
                    if (key === 'paymentTypes' || key === 'shippingMethods') {
                        return
                    }
                    const state = next[key]
                    if (!state) {
                        return
                    }
                    const type = state.type || 'text'
                    if (type === 'date') {
                        const preset = state.preset || ''
                        const hasPreset = ['today', 'last_7_days', 'last_30_days', 'last_90_days', 'last_12_months'].includes(preset)
                        const hasCustom = (state.from !== '' && state.from != null) || (state.to !== '' && state.to != null)
                        if (hasPreset || hasCustom) {
                            columnFilters[key] = {
                                type: 'date',
                                preset: preset || 'custom_range',
                                from: state.from != null ? state.from : '',
                                to: state.to != null ? state.to : '',
                                operator: state.operator === 'is_not' ? 'is_not' : 'is',
                            }
                        }
                        return
                    }
                    if (type === 'number') {
                        if ((state.from !== '' && state.from != null) || (state.to !== '' && state.to != null)) {
                            columnFilters[key] = {
                                type,
                                from: state.from != null ? state.from : '',
                                to: state.to != null ? state.to : '',
                                operator: 'between',
                            }
                        }
                        return
                    }
                    if (type === 'text') {
                        if (state.value != null && String(state.value).trim() !== '') {
                            columnFilters[key] = {
                                type: 'text',
                                value: String(state.value).trim(),
                                operator: state.operator === 'is_not' ? 'is_not' : 'is',
                            }
                        }
                        return
                    }
                    if ((type === 'select' || type === 'async-select') && Array.isArray(state.values) && state.values.length) {
                        columnFilters[key] = {
                            type: type === 'async-select' ? 'async-select' : 'select',
                            values: state.values,
                            operator: state.operator === 'is_not' ? 'is_not' : 'is',
                            valueLabels: state.valueLabels && typeof state.valueLabels === 'object' ? state.valueLabels : {},
                        }
                        return
                    }
                    if (Array.isArray(state.values) && state.values.length) {
                        columnFilters[key] = {
                            type: 'select',
                            values: state.values,
                            operator: state.operator === 'is_not' ? 'is_not' : 'is',
                        }
                    }
                })

                this.filters.selected.columnFilters = columnFilters
                this.tables.salesOrders.currentPage = 1
                this.syncUrlQueryFilters()
                this.refreshSalesOrdersTable()
            },

            urlQueryFilterConfig() {
                return {
                    search: { path: 'tables.salesOrders.filter', query: 'q' },
                    page: { path: 'tables.salesOrders.currentPage', query: 'page', type: 'number' },
                    perPage: { path: 'tables.salesOrders.perPage', query: 'perPage', type: 'number' },
                    sortBy: { path: 'tables.salesOrders.sortBy', query: 'sortBy' },
                    sortDesc: { path: 'tables.salesOrders.sortDesc', query: 'sortDesc', type: 'boolean' },
                    fields: [
                        { path: 'filters.selected.dateFrom', query: 'from' },
                        { path: 'filters.selected.dateTo', query: 'to' },
                        { path: 'filters.selected.dateFilter', query: 'period', emptyValue: null },
                        { path: 'filters.selected.status', query: 'status', type: 'array' },
                        { path: 'filters.selected.salesReps', query: 'salesReps', type: 'array' },
                        { path: 'filters.selected.paymentTypes', query: 'paymentTerms', type: 'array' },
                        { path: 'filters.selected.paymentTypesOperator', query: 'paymentTermsOp', emptyValue: 'is' },
                        { path: 'filters.selected.shippingMethods', query: 'shipping', type: 'array' },
                        { path: 'filters.selected.shippingMethodsOperator', query: 'shippingOp', emptyValue: 'is' },
                        { path: 'filters.selected.tags', query: 'tags', type: 'array' },
                        { path: 'filters.selected.columnFilters', query: 'cf', type: 'json', emptyValue: {} },
                    ],
                }
            },

            onUrlQueryFiltersApplied() {
                this.refreshSalesOrdersTable()
            },

            loadCustomerFilterOptions({ query, page, perPage }) {
                return axios.post('api/lists/customers/getcustomers', {
                    page: page || 1,
                    perPage: perPage || 25,
                    search: query || '',
                    searchNameOnly: true,
                    sortBy: 'name',
                    sortDesc: false,
                }).then((res) => {
                    const customers = res.data.customers || []
                    const total = Number(res.data.total) || 0
                    const currentPage = page || 1
                    const size = perPage || 25

                    return {
                        options: customers.map((customer) => ({
                            id: customer.id,
                            label: customer.name,
                        })),
                        hasMore: currentPage * size < total,
                    }
                }).catch(() => ({
                    options: [],
                    hasMore: false,
                }))
            },

            mobileStatusVariant(status) {
                if (status === 'Closed') return 'success'
                if (status === 'Cancelled') return 'secondary'
                if (status === 'Pending') return 'warning'
                if (status === 'Dispatched' || status === 'Confirmed') return 'info'
                return 'primary'
            },

            findCategoryName(id) {
                let index = this.findIndex(this.tables.salesOrders.status, 'id', id)
                return this.tables.salesOrders.status[index].label
            },

            getCategories() {
                let url = 'api/orders/sales-orders/getcategoriesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.tables.salesOrders.status = res.data.categories
                }, () => {
                    this.has_error = true
                })
            },

            getSalesRepsFilter() {
                let url = 'api/lists/sales-reps/getsalesrepsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.filters.salesReps = res.data.salesReps
                }, () => {
                    this.has_error = true
                })
            },

            getPaymentTermsFilter() {
                fetchActivePaymentTerms().then((terms) => {
                    this.filters.paymentTypes = paymentTermsToFilterOptions(terms)
                })
            },

            getShippingMethodsFilter() {
                fetchActiveShippingMethods().then((methods) => {
                    this.filters.shippingMethods = shippingMethodsToFilterOptions(methods)
                })
            },

            getOrderTagsFilter() {
                let url = 'api/orders/sales-orders/getordertagsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.filters.tags = res.data.tags
                }, () => {
                    this.has_error = true
                })
            },

            processStatusQueryRoute(status) {
                if (status == 'create') {
                    this.$router.push({ name: 'SalesOrdersCreate' })
                } else {
                    this.filters.selected.status = []
                    if (status) {
                        if (status == 'confirmed') {
                            this.filters.selected.status.push('Confirmed')
                        } else if (status == 'dispatched') {
                            this.filters.selected.status.push('Dispatched')
                        }
                    }
                }
            },

            getColSaves() {
                let url = 'api/remembertable/getcolsaves/salesorders'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            const merged = this.mergeColSaves(this.tables.salesOrders.fields, res.data.colSaves.column_array)
                            if (merged) {
                                this.tables.salesOrders.userFields = merged
                            }
                        }

                        this.initSalesOrders()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            saveColSaves(fields) {
                const normalized = this.normalizeColumnOrder(fields)
                this.tables.salesOrders.userFields = normalized
                let url = 'api/remembertable/savecolsaves'
                axios.post(url, {
                    area: 'salesorders',
                    fields: this.formatColSavesPayload(normalized)
                })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
            },

            forceRerender() {
                this.tables.salesOrders.ready = 0
                let tempFields = this.tables.salesOrders.fields
                this.tables.salesOrders.fields = []
                this.$nextTick(() => {
                    this.tables.salesOrders.fields = tempFields
                    this.tables.salesOrders.ready = 1
                })
            }
        },
    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.salesOrders.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.salesOrders.totalRows
                let currentPage = this.tables.salesOrders.currentPage
                let perPage = this.tables.salesOrders.perPage

                if (!totalRows) {
                    return 'Showing 0 of 0 rows'
                }

                let from = ((currentPage - 1) * perPage) + 1
                let to = Math.min(currentPage * perPage, totalRows)

                return 'Showing ' + from + ' to ' + to + ' of ' + totalRows + ' rows'
            },

            visibleFields() {
                return this.buildVisibleFields(this.tables.salesOrders.fields, this.tables.salesOrders.userFields)
            },

            shopifyFilterFields() {
                const excludedKeys = new Set([
                    'checkbox',
                    'actions',
                    'status',
                    'sales_rep',
                    'sale_order_tag',
                    'date_shipped',
                    'payment_method',
                ])

                const numberKeys = new Set([
                    'id',
                    'credit_total',
                    'shipping_total',
                    'discount_total',
                    'percent_discounts',
                    'net_total',
                    'total',
                    'balance',
                    'cogs',
                ])

                const dateKeys = new Set([
                    'date',
                ])

                const fields = [
                    {
                        key: 'paymentTypes',
                        label: 'Payment Terms',
                        type: 'select',
                        options: this.filters.paymentTypes,
                    },
                    {
                        key: 'shippingMethods',
                        label: 'Shipping Methods',
                        type: 'select',
                        options: this.filters.shippingMethods,
                    },
                ]

                this.visibleFields.forEach((column) => {
                    if (!column || !column.key || excludedKeys.has(column.key)) {
                        return
                    }
                    if (parseInt(column.visible) !== 1) {
                        return
                    }

                    if (column.key === 'customer') {
                        fields.push({
                            key: 'customer',
                            label: column.label || 'Customer Name',
                            type: 'async-select',
                            loadOptions: this.loadCustomerFilterOptions,
                        })
                        return
                    }

                    let type = 'text'
                    if (numberKeys.has(column.key)) {
                        type = 'number'
                    } else if (dateKeys.has(column.key)) {
                        type = 'date'
                    }

                    fields.push({
                        key: column.key,
                        label: column.label || column.key,
                        type,
                    })
                })

                return fields
            },

            shopifyFilterValue() {
                const value = {
                    paymentTypes: {
                        type: 'select',
                        values: this.filters.selected.paymentTypes || [],
                        operator: this.filters.selected.paymentTypesOperator === 'is_not' ? 'is_not' : 'is',
                    },
                    shippingMethods: {
                        type: 'select',
                        values: this.filters.selected.shippingMethods || [],
                        operator: this.filters.selected.shippingMethodsOperator === 'is_not' ? 'is_not' : 'is',
                    },
                }

                const columnFilters = this.filters.selected.columnFilters || {}
                Object.keys(columnFilters).forEach((key) => {
                    value[key] = { ...columnFilters[key] }
                })

                return value
            },

            hasActiveSalesOrderFilters() {
                const selected = this.filters.selected
                const columnFilters = selected.columnFilters || {}
                const hasColumnFilters = Object.keys(columnFilters).some((key) => {
                    const state = columnFilters[key]
                    if (!state) {
                        return false
                    }
                    if (state.type === 'date') {
                        const preset = state.preset || ''
                        if (['today', 'last_7_days', 'last_30_days', 'last_90_days', 'last_12_months'].includes(preset)) {
                            return true
                        }
                        return (state.from !== '' && state.from != null) || (state.to !== '' && state.to != null)
                    }
                    if (state.type === 'number') {
                        return (state.from !== '' && state.from != null) || (state.to !== '' && state.to != null)
                    }
                    if (state.type === 'text') {
                        return state.value != null && String(state.value).trim() !== ''
                    }
                    return Array.isArray(state.values) && state.values.length > 0
                })

                return Boolean(
                    this.tables.salesOrders.filter
                    || selected.dateFrom
                    || selected.dateTo
                    || selected.dateFilter
                    || (selected.salesReps && selected.salesReps.length)
                    || (selected.status && selected.status.length)
                    || (selected.paymentTypes && selected.paymentTypes.length)
                    || (selected.shippingMethods && selected.shippingMethods.length)
                    || (selected.tags && selected.tags.length)
                    || hasColumnFilters
                )
            },
	    },
	    mounted() {
            this.getColSaves()
            this.getSalesRepsFilter()
            this.getPaymentTermsFilter()
            this.getShippingMethodsFilter()
            this.getOrderTagsFilter()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-sales-orders-edit-sales-order':
                        this.modals['edit-sales-order'].edit = []

                        break
                    case 'modal-inventory-sales-orders-create-sales-order':
                        this.modals['create-sales-order'].create = {}

                        break
                    case 'modal-lists-customers-receive-payment':
                        this.modals['receive-payment'].active = 0

                        break
                    case 'modal-lists-customers-apply-credit':
                        this.modals['apply-credit'].active = 0

                        break
                    case 'modal-common-adjust-columns':
                        this.modals['adjust-columns'].active = 0
                        this.modals['adjust-columns'].fields = []

                        break
                    case 'modal-common-export-columns':
                        this.modals['export-columns'].active = 0
                        this.modals['export-columns'].fields = []

                        break
                    case 'modal-common-export-line-items':
                        this.modals['export-columns'].active = 0

                        break
                }
            })

            // pusher
            Echo.channel('order-details-updated')
                .listen('OrderDetailsUpdated', (e) => {
                    this.refreshSalesOrdersTable()
                })
	    },

        created() {

        },

        watch: {
            'tables.salesOrders.filter'() {
                this.tables.salesOrders.currentPage = 1
                this.syncUrlQueryFilters()
            },
            'tables.salesOrders.currentPage'() {
                this.syncUrlQueryFilters()
            },
            'tables.salesOrders.perPage'() {
                this.syncUrlQueryFilters()
            },
            'tables.salesOrders.sortBy'() {
                this.syncUrlQueryFilters()
            },
            'tables.salesOrders.sortDesc'() {
                this.syncUrlQueryFilters()
            },
            $route(to, from) {
                if (to.params.status !== from.params.status) {
                    this.processStatusQueryRoute(to.params.status)
                    this.syncUrlQueryFilters()
                    this.refreshSalesOrdersTable()
                }
            }
        }
    }
</script>
<style lang="scss">
    .sales-orders-filters {
        gap: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .sales-orders-filter {
        margin-bottom: 0.25rem;
    }

    .sales-orders-filter--search {
        flex: 1 1 100%;
        min-width: 280px;
        max-width: 100%;
    }

    .sales-orders-filter--date {
        flex: 1 1 150px;
        min-width: 140px;
        max-width: 190px;
    }

    .sales-orders-filter--select {
        flex: 1 1 160px;
        min-width: 150px;
        max-width: 220px;
    }

    .sales-orders-filter--perpage {
        flex: 0 0 72px;
        min-width: 72px;
        max-width: 90px;
    }

    .sales-orders-mobile__card {
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 0.35rem;
        padding: 0.85rem;
        margin-bottom: 0.75rem;
        background: #fff;
    }

    .sales-orders-mobile__meta {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0.5rem;
        font-size: 0.85rem;

        span {
            display: block;
            font-size: 0.75rem;
        }
    }

    .vue-treeselect__control {
        font-size: 0.875rem !important;
    }

    .sales-orders-table {
        height: 75vh;
        font-size: 9pt;

        .sales-orders-thumbs {
            width: 80px;
            max-height: 80px;
        }

        .sales-orders-table-style-actions {
            .actions-icons {
                text-align: center;
            }
        }

        .sales-orders-table-style-datetime {
            width: 110px;

            .actions-icons {
                text-align: center;
            }
        }

        .tag-badges {
            margin: 2px;
            padding: 5px;
        }
    }
</style>
